import DateForm from './DateForm'
Vue.component('DateForm', DateForm)

import ResultTable from './ResultTable'
Vue.component('ResultTable', ResultTable)



// WEBPACK FOOTER //
// ./src/js/components/PasswordGenerator/index.js